import React from 'react'
import Slider from 'react-slick'

const allProjects = [
  {
    pImg: "/assets/project/img1.jpg",
    pText: "New MEG Regeneration Unit at Margham,(Dubai Petroleum), UAE "
  },
  {
    pImg: "/assets/project/img2.png",
    pText: "Jurassic Production Facility (KOC), Kuwait "
  },
  {
    pImg: "/assets/project/img3.jpg",
    pText: "Early Production Facility Ph1, Iraq"
  },
  {
    pImg: "/assets/project/img4.png",
    pText: "Provision of Compression Services Ph5 (BAPCO), Bahrain"
  },
  {
    pImg: "/assets/project/projects.jpg",
    pText: " Dubai Harbour, Dubai"
  },
  {
    pImg: "/assets/project/projects.webp",
    pText: "Atlantis The Royal, Dubai"
  },
  {
    pImg: "/assets/project/project2.avif",
    pText: "Museum of The Future, Dubai"
  },
  {
    pImg: "/assets/project/project3.webp",
    pText: "One Za'abeel, Dubai"
  },
  {
    pImg: "/assets/project/project4.png",
    pText: " Expo 2020, Dubai"
  },
  {
    pImg: "/assets/project/project6.webp",
    pText: "Officers Club & Hotel, Abu Dubai"
  },
]

function ProjectSlider() {
  const settings = {
    dots: false,
    infinite: true,
    speed: 5000,              // animation speed
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,         // ⚡ continuous scroll banane ke liye
    cssEase: "linear",        // smooth scroll ke liye
    arrows: false,
    pauseOnHover: false,      // hover pe bhi rukna nahi chahiye
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  };

  return (
    <Slider {...settings}>
      {allProjects?.map((e, i) => (
        <div key={i} className="max-w-[96%] w-full mr-auto relative">
          <img
            src={e?.pImg}
            className="h-[300px] w-full object-cover"
            alt=""
          />
          <div className="absolute bottom-0 left-0 w-full">
            <div className="relative w-full pl-[20px] pr-[20px] inline-block">
              <div className="absolute inset-0 bg-black/70 rounded-md z-0"></div>
              <h6 className="relative w-full z-10 font-[400] font-kanit 
                text-[18px] leading-[26px]          
                sm:text-[16px] sm:leading-[28px]    
                md:text-[16px] md:leading-[32px]   
                lg:text-[16px] lg:leading-[36px]    
                xl:text-[16px] xl:leading-[40px]    
                tracking-[0.2px] text-white">
                {e?.pText}
              </h6>
            </div>
          </div>
        </div>
      ))}
    </Slider>
  )
}

export default ProjectSlider
